<template>
  <UiDrawer v-model="showModal" placement="bottom">
    <div class="present-panel">
      <template v-if="!giftingEnabled">
        <UiEmpty class="ui-empty" hook="vw" tip="敬请期待" />
      </template>
      <template v-else>
        <div class="text-tip">
          <span>可点击下方战队图标</span>,去战队主页为战队送礼加油！
        </div>
        <ul class="clan-list" v-if="cheerForList.length !== 0">
          <li
            class="clan"
            v-for="(item, key) in cheerForList"
            :key="key"
            @click="handleClanClick(item)"
          >
            <div class="icon">
              <div
                class="head"
                :style="{ 'background-image': `url(${item?.avatar})` }"
              ></div>
              <div class="frame"></div>
            </div>
            <div class="hot">
              <UiLabel class="clan-name" shadow-color="#fff" text-color="#6D0308">{{ item?.name }}</UiLabel>
              <div class="clan-hot">
                <i></i>
                <div class="clan-count">{{ countShow(item.popularity) }}</div>
              </div>
            </div>
          </li>
        </ul>
      </template>
    </div>
    <template #close="{ close }">
      <button class="btn-close" @click="close" />
    </template>
  </UiDrawer>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useAppStore, useStageStore } from '@/store'
import { useModal } from '@/composables/useModal'
import * as api from '@/service/index'
import UiDrawer from '@/components/ui-drawer.vue'
import UiEmpty from '@/components/ui-empty'
import UiLabel from '@/components/ui-label.vue'

const emit = defineEmits(['openPresent'])

const appStore = useAppStore()
const stageStore = useStageStore()

const showModal = ref(false)
const cheerForList = ref([])
const token = computed(() => appStore.token)
const giftingEnabled = computed(() => stageStore.giftingEnabled)

useModal('present-panel', showModal, {
  onOpen() {
    if (!token.value) return
    if (giftingEnabled.value) fetchCheerList()
  }
})

async function fetchCheerList() {
  try {
    const response = await api.getGiftTeamList(token.value)
    cheerForList.value = shuffleArray(response.data)
  } catch (err) {
    console.error(err)
  }
}

// Fisher-Yates 洗牌
function shuffleArray(array) {
  const result = [...array]
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]]
  }
  return result
}

function countShow(hot) {
  if (!hot) return 0
  if (hot < 10000) return hot
  if (hot < 99999999) return (((hot / 10000) * 100) / 100).toFixed(2) + '万'
  return '9999万+'
}

function handleClanClick(item) {
  emit('openPresent', item)
}
</script>

<style lang="scss" scoped>
.present-panel {
  box-sizing: border-box;
  width: 100%;
  // 极端扁屏 (≥4:1) 下 get_vw(408) 会超视口高, 用 min() clamp 到视口高
  height: min(#{get_vw(408)}, 100vh);
  background-color: rgba(0, 0, 0, 0.85);
  padding: 0 get_vw(36);

  .ui-empty {
    filter: invert(1); // 深底 drawer 上反色 icon (源图是黑, 反色后变白)
  }

  .text-tip {
    height: get_vw(70);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-top: get_vw(5);
    color: #FFFFFF;
    font-size: get_vw(20);
    span { color: #D8B569; }
  }

  .clan-list {
    height: calc(100% - get_vw(70));
    // grid: 5 列固定, 列间距由 justify-content: space-between 分配
    // (相比 flex + space-between, grid 最后一行不满时 item 从左到右紧凑排, 不会被拉散)
    display: grid;
    grid-template-columns: repeat(5, get_vw(267));
    justify-content: space-between;
    align-content: flex-start;
    overflow-y: auto;
    overflow-x: hidden;
    // 隐藏滚动条: webkit 主战场; firefox / IE 补齐
    &::-webkit-scrollbar { display: none; }
    scrollbar-width: none;
    -ms-overflow-style: none;

    .clan {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      height: get_vw(110);
      background: linear-gradient(180deg, #FFE0E0, #FFF);
      border: get_vw(2) solid #FFFFFF;
      margin-bottom: get_vw(16);

      .icon {
        position: relative;
        width: get_vw(92);
        height: get_vw(100);
        margin: 0 get_vw(12) 0 get_vw(23);
        @include avatar_icon_frame;
      }
      .hot {
        width: get_vw(100);
        .clan-name {
          font-size: get_vw(20);
          display: inline-flex;
          margin-bottom: get_vw(7.5);
        }
        .clan-hot {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: get_vw(20);
          line-height: 1.2;
          color: #C64F52;
          overflow-wrap: anywhere;
          i {
            width: get_vw(21);
            height: get_vw(24);
            background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/Q08sFuxg.png);
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            margin-right: get_vw(2);
          }
          .clan-count { flex: 1; }
        }
      }
    }
  }
}

.btn-close {
  position: absolute;
  top: get_vw(24);
  right: get_vw(24);
  width: get_vw(50);
  height: get_vw(25);
  background-image: url('https://website.xdcdn.net/poster/58881/20250717/KuEwgSJr.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  z-index: 100;
}
</style>
